var bounceOut = require('./bounce-out')

function bounceIn(t) {
  return 1.0 - bounceOut(1.0 - t)
}

module.exports = bounceIn


//////////////////
// WEBPACK FOOTER
// ../node_modules/eases/bounce-in.js
// module id = 92
// module chunks = 0